import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Link do WhatsApp (Lembre de trocar o 99999... pelo seu número real)
  const whatsappLink =
    "https://wa.me/5571982946930?text=Olá,%20vim%20pelo%20site%20e%20gostaria%20de%20um%20orçamento!";

  // Efeito para detectar o scroll e mudar a cor do menu
  useEffect(() => {
    const handleScroll = () => {
      // Se descer mais de 50px, ativa o fundo escuro
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 px-6 py-4 transition-all duration-300 ${
        scrolled
          ? "bg-slate-950/90 backdrop-blur-md border-b border-white/10 shadow-lg" // Visual quando rola para baixo
          : "bg-transparent border-transparent" // Visual quando está no topo
      }`}
    >
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div className="flex items-center gap-4">
          <img
            src="/assets/ralui-tech.png"
            alt="Logo Ralui Tech"
            className="w-20 h-20 object-contain"
          />
          <span className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">
            RALUI TECH
          </span>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex gap-8 items-center">
          <a href="#home" className="hover:text-purple-400 transition-colors">
            Início
          </a>

          <a href="#about" className="hover:text-purple-400 transition-colors">
            Sobre a Empresa
          </a>

          <a
            href="#services"
            className="hover:text-purple-400 transition-colors"
          >
            Serviços
          </a>

          {/* Link Simples para o Formulário */}
          <a
            href="#contact"
            className="hover:text-purple-400 transition-colors"
          >
            Contato
          </a>

          {/* Botão de destaque para o WhatsApp */}
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-2 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full hover:shadow-lg hover:shadow-purple-500/50 transition-all font-bold text-sm"
          >
            WhatsApp / Orçamento
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden p-2 hover:bg-white/10 rounded-lg transition-colors"
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-slate-950/95 backdrop-blur-lg border-b border-white/10 py-4 px-6 space-y-4 shadow-2xl">
          <a
            href="#home"
            onClick={() => setMenuOpen(false)}
            className="block py-2 text-lg hover:text-purple-400 transition-colors border-b border-white/5"
          >
            Início
          </a>

          <a
            href="#about"
            onClick={() => setMenuOpen(false)}
            className="block py-2 text-lg hover:text-purple-400 transition-colors border-b border-white/5"
          >
            Sobre a Empresa
          </a>

          <a
            href="#services"
            onClick={() => setMenuOpen(false)}
            className="block py-2 text-lg hover:text-purple-400 transition-colors border-b border-white/5"
          >
            Serviços
          </a>

          <a
            href="#contact"
            onClick={() => setMenuOpen(false)}
            className="block py-2 text-lg hover:text-purple-400 transition-colors border-b border-white/5"
          >
            Contato (Email)
          </a>

          {/* Botão WhatsApp Mobile */}
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setMenuOpen(false)}
            className="block py-2 text-lg text-green-400 font-bold hover:text-green-300 transition-colors"
          >
            Chamar no WhatsApp
          </a>
        </div>
      )}
    </nav>
  );
}
